const dialogOverlay = "fixed inset-0 z-50 flex items-center justify-center bg-black/60";

const dialog = "w-full max-w-lg rounded-xl bg-card border border-border p-4 sm:p-6 shadow-2xl";

const dialogHeader = "text-center mb-6";

const dialogTitleWrapper = "flex items-center justify-center gap-2 mb-2";

const dialogTitleIcon = "w-5 h-5 text-primary";

const dialogTitle = "text-xl font-bold text-foreground";

const cancelButton =
  "mt-4 w-full rounded-lg border border-border px-4 py-2.5 text-sm " + "text-muted-foreground hover:bg-accent transition-colors duration-200";

const statusGrid = "grid grid-cols-2 gap-3";

const statusButton =
  "relative flex items-center gap-3 rounded-xl border px-4 py-3.5 text-left text-sm " +
  "transition-all duration-200 hover:shadow-md hover:scale-[1.02] active:scale-[0.98] " +
  "focus:outline-none focus:ring-2 focus:ring-ring/50 focus:ring-offset-2 focus:ring-offset-card";

const statusButtonActive = "ring-2 ring-offset-2 ring-primary shadow-md";

const statusIconWrapper = "shrink-0 w-9 h-9 rounded-lg flex items-center justify-center";

const statusLabel = "font-semibold leading-tight";

const activeCheck = "absolute top-2 right-2 w-4 h-4 text-primary";

const statusPending = "border-l-4 border-l-warning bg-warning/10 hover:bg-warning/15";

const statusPendingIcon = "bg-warning/15 text-warning";

const statusProcessing = "border-l-4 border-l-info bg-info/10 hover:bg-info/15";

const statusProcessingIcon = "bg-info/15 text-info";

const statusPaid = "border-l-4 border-l-brand-purple bg-brand-purple/10 hover:bg-brand-purple/15";

const statusPaidIcon = "bg-brand-purple/15 text-brand-purple";

const statusCompleted = "border-l-4 border-l-success bg-success/10 hover:bg-success/15";

const statusCompletedIcon = "bg-success/15 text-success";

const statusFailed = "border-l-4 border-l-destructive bg-destructive/10 hover:bg-destructive/15";

const statusFailedIcon = "bg-destructive/15 text-destructive";

const statusSkipped = "border-l-4 border-l-muted-foreground/60 bg-muted/40 hover:bg-muted";

const statusSkippedIcon = "bg-muted text-muted-foreground";

export {
  dialogOverlay,
  dialog,
  dialogHeader,
  dialogTitleWrapper,
  dialogTitleIcon,
  dialogTitle,
  cancelButton,
  statusGrid,
  statusButton,
  statusButtonActive,
  statusIconWrapper,
  statusLabel,
  activeCheck,
  statusPending,
  statusPendingIcon,
  statusProcessing,
  statusProcessingIcon,
  statusPaid,
  statusPaidIcon,
  statusCompleted,
  statusCompletedIcon,
  statusFailed,
  statusFailedIcon,
  statusSkipped,
  statusSkippedIcon,
};
